<template>
  <div id="app">
    <a href="https://www.servirbrasil.org.br/" target="_blank"
      ><img
        src="https://www.servirbrasil.org.br/wp-content/uploads/2020/10/Full@2x.png"
        alt="Frente Servir Brasil"
        height="100"
      /><br />Voltar para Servir Brasil</a
    ><br /><br />
    <h1><strong>PEC 32/2020</strong><br />Plenário da Câmara dos Deputados</h1>
    <div id="chartdiv"></div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/App.vue